import type { SelectedTag } from '../../../components/assets/details/types';
import type { Asset, AssociatedDevice, Masterdata, Tag } from '../../../components/assets/types';
import type { assetDeleteDialogClose, assetDeleteDialogOpen } from '../../../reducers/assets/assetsSlice';

export enum AssetsListDetailTab {
    ASSET_DETAILS = 'details',
    TAG_LIST = 'group',
    DEVICE_LIST = 'device',
}

export interface AssetListDetailOwnProperties {
    asset: Asset;
    onClose: () => void;
    toggleConfirmDialog: (opened: boolean, newRowId: string | null, discardChangesCallback: () => void) => void;
    toggleUnsavedAssetChanges: (unsavedChanges: boolean) => void;
}

export interface AssetListDetailPropertiesFromState {
    associatedDevices: { [key: string]: AssociatedDevice[] };
    assetUpdating: boolean;
    assetDeleting: boolean;
    displayDeleteDialog: boolean;
    deletionSuccessful: boolean;
    deletionErrorMessageCode: string | null;
    availableTags: Tag[];
    assetTagsUpdating: boolean;
    currentAssetDetailsTab: AssetsListDetailTab;
}

export interface AssetListDetailPropsFromDispatch {
    fetchSelectedDevices: (assetId: string, associatedDevices: { [key: string]: AssociatedDevice[] }) => Promise<void>;
    updateAssetTags: (asset: Asset, tags: SelectedTag[]) => Promise<void>;
    openDeleteDialog: () => { type: typeof assetDeleteDialogOpen.type };
    closeDeleteDialog: () => { type: typeof assetDeleteDialogClose.type };
    deleteAsset: (asset: Asset) => Promise<void>;
    updateAsset: (originalAsset: Asset, updatedAsset: Asset) => Promise<void>;
    updateMasterdata: (
        asset: Asset,
        originalMasterdata: Masterdata | null,
        updatedMasterdata: Masterdata
    ) => Promise<void>;
    createAssetTags: (assetTags: SelectedTag[], assetToUpdate?: Asset) => Promise<void>;
    changeAssetDetailsTab: (selectedTab: AssetsListDetailTab) => void;
    resetAssetUpdateState: () => void;
    resetAssetDeletionState: () => void;
}
